















































import {Component, Mixins} from 'vue-property-decorator'
import ScrollToLoad from "@/helpers/mixins/ScrollToLoad";
import api from "@/api/api";
import ProductListItem from "@/components/External/ProductListItem.vue";
import BrandCategoryFilter from "@/views/topicPages/components/BrandCategoryFilter.vue";
import ProductCard from "@/helpers/mixins/ProductCard";

@Component({
  components: {
    ProductListItem,
    BrandCategoryFilter,
  }
})
export default class BrandProducts extends Mixins(ScrollToLoad, ProductCard) {
  public itemCountPerLoading = 5
  public selectedCate = ""
  public selectedSortInfo = ""
  public categoryList = [] as object[]
  public brandBanner = ""
  public query = {
    pageIndex: 1,
    pageSize: 10,
  }
  public sortInfo = 'default'
  public selectedCategory = ''

  get lang(){
    return this.$store.getters.locale
  }

  mounted() {
    this.getBrandDetails()
  }

  get BrandId() {
    return this.$route.params.brandId
  }

  get ApiRequiredData() {
    let data = {}
    if (this.lang === 'en') {
      data = {
        brandId: +this.BrandId,
        pageIndex: this.query.pageIndex,
        pageSize: this.query.pageSize,
        sortRule: this.sortInfo,
        Filters: {
          CategoryNameEn: [this.selectedCategory]
        }
      }
    } else {
      data = {
        brandId: +this.BrandId,
        pageIndex: this.query.pageIndex,
        pageSize: this.query.pageSize,
        sortRule: this.sortInfo,
        Filters: {
          CategoryNameCn: [this.selectedCategory]
        }
      }
    }
    return data
  }

  addNewDataList() {
    this.getBrandDetails()
  }

  async getBrandDetails() {
    console.log(this.ApiRequiredData, this.BrandId)
    try{
      const res = await api.getBrandDetails(this.ApiRequiredData)
      this.pageCount = res.data.pageCount
      if(this.query.pageIndex === 1){
        this.displayedDataList = res.data.data.results
      }else{
        this.displayedDataList = [...this.displayedDataList, ...res.data.data.results]
      }
      if(this.categoryList.length === 0 && this.brandBanner === ""){
        this.categoryList = res.data.data.aggregations
        this.brandBanner = res.data.data.chosenBrand.customBanner
      }
      this.query.pageIndex += 1
      console.log({ res })
    }catch (e){
      console.log(e)
    }
  }

  async filterByPrice(value){
    console.log(value)
    if(value === 1){
      this.sortInfo = "sellingPrice-asc"
    }else{
      this.sortInfo = "sellingPrice-desc"
    }
    this.query.pageIndex = 1
    await this.getBrandDetails()
  }

  async filterByTime(value){
    if(value === 1){
      this.sortInfo = "createTime-asc"
    }else{
      this.sortInfo = "createTime-desc"
    }
    this.query.pageIndex = 1
    await this.getBrandDetails()
  }
  async filterByDefault(){
    this.sortInfo = 'default'
    await this.getBrandDetails()
  }
  async selectCategory(value){
    this.selectedCategory = value
    this.query.pageIndex = 1
    await this.getBrandDetails()
  }

}
